import type { IconData } from '@stacksjs/iconify-core'

export const weatherCloudSunFine: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 19.055H32v6.09h-1.53Zm-1.52-7.62H32v1.52h-3.05Zm0 13.71h1.52v1.53h-1.52Zm0-7.62h1.52v1.53h-1.52Zm0-13.71h1.52v1.52h-1.52Zm-1.52 22.86h1.52v1.52h-1.52Zm0-10.67h1.52v1.52h-1.52Zm0-10.67h1.52v1.53h-1.52ZM3.05 28.195h24.38v1.52H3.05Zm18.28-12.19h1.52v1.52h-1.52Zm0-13.72h1.52v3.05h-1.52Zm-1.52 15.24h1.52v1.53h-1.52Zm-4.57-12.19h1.52v1.53h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm0 6.09h4.57v1.53h3.05v1.52h1.52v3.05h4.58v-6.1H25.9v-1.52h-1.52v-1.52h-4.57v1.52h-7.62v1.52h-1.53v1.53h3.05zm-3.05 9.15h1.53v1.52h-1.53Zm-1.52-1.53h1.52v1.53H9.14Zm0-6.09h1.52v1.52H9.14Zm0 6.09v-4.57H7.62v3.05H3.05v1.52zm-7.62 9.15h1.53v1.52H1.52Zm0-9.15h1.53v1.53H1.52ZM0 19.055h1.52v7.62H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default weatherCloudSunFine
